module.exports = require("class-propper");


//////////////////
// WEBPACK FOOTER
// external "class-propper"
// module id = 5
// module chunks = 0 1 2 4